var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.929,
    height: 24.991,
    viewBox: "0 0 29.929 24.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.909 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_281fbac6-2f37-448a-a675-1cd1f188d217",
    "data-name": "281fbac6-2f37-448a-a675-1cd1f188d217",
    d: "M29.02,2.731a13.912,13.912,0,0,1-4.011,1.955A5.725,5.725,0,0,0,14.965,8.519V9.8a13.621,13.621,0,0,1-11.5-5.79s-5.111,11.5,6.39,16.612A14.885,14.885,0,0,1,.909,23.176c11.5,6.388,25.556,0,25.556-14.7a5.7,5.7,0,0,0-.1-1.06A9.862,9.862,0,0,0,29.02,2.731Z",
    transform: "translate(-0.909 -2.718)",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.818
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIcon);
export default __webpack_public_path__ + "static/media/WhiteIcon.4f50d2a6333f536efb390e174fb671a2.svg";
export { ForwardRef as ReactComponent };